import React, { memo, useEffect } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

import connectOptions, { mergeProps } from '../../utils/connectOptions';
import { usePopupContext } from '../../contexts/PopupContext';

const CompanyTargetCreateContainer = props => {
  const { hasPopup, openPopup } = usePopupContext();

  useEffect(() => {
    if (!props.user) return;
    if (hasPopup()) return;

    openPopup('AddCompanyTargetPopup');
  });

  return <Helmet title="Create Target Company" />;
};

const mapStateToProps = state => ({
  user: state.auth.get('user', null),
});

export { CompanyTargetCreateContainer };
export default connect(mapStateToProps, {}, mergeProps, connectOptions)(memo(CompanyTargetCreateContainer));
